module.exports = __webpack_public_path__ + "img/el.368bc9df.svg";